import {useContext} from "react";
import {AdviceListContext} from "../state/adviceContext";
import {AdviceQuery} from "../queries/AdviceQuery";

const useAdviceFavorite = () => {
    const {dispatch} = useContext(AdviceListContext)

    const addToFavorite = (id) => {
        dispatch({action: "addToFavorite", payload: id})
        AdviceQuery.addToFavorite(id)
            .catch( () => dispatch({action: "removeFromFavorite", payload: id}) ) // revert action if something goes wrong
    }

    const removeFromFavorite = (id) => {
        dispatch({action: "removeFromFavorite", payload: id})
        AdviceQuery.removeFromFavorite(id)
            .catch( () => dispatch({action: "addToFavorite", payload: id}) ) // revert action if something goes wrong
    }

    return {addToFavorite, removeFromFavorite}
}

export {useAdviceFavorite}
